export const CLAIM_OFFER_QUERY_KEY = "claim_offer";
export const CLAIM_LOGIN_QUERY_KEY = "claim_login";
export const CLAIM_LOGIN_QUERY_VALUE = "1";

// 只用於接續本次登入回呼，不代表已登入或符合領券資格。
export function getIsClaimLoginReturn(value) {
  return value === CLAIM_LOGIN_QUERY_VALUE;
}

export function withoutClaimLogin(query) {
  const nextQuery = { ...query };
  delete nextQuery[CLAIM_LOGIN_QUERY_KEY];
  return nextQuery;
}

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// 路由 query 可能是字串或陣列；領券入口只接受單一合法 UUID
export function getClaimOfferUuid(value) {
  if (typeof value !== "string") return "";
  const uuid = value.trim();
  return UUID_PATTERN.test(uuid) ? uuid : "";
}

export function withoutClaimOffer(query) {
  const nextQuery = { ...query };
  delete nextQuery[CLAIM_OFFER_QUERY_KEY];
  return nextQuery;
}

// 推播等外部連結進 VIP 卡後要開啟的頁面；只接受白名單值
export const OPEN_PAGE_QUERY_KEY = "open";
export const OPEN_CLAIMED_COUPONS = "claimed_coupons";

const OPEN_PAGES = [OPEN_CLAIMED_COUPONS];

export function getOpenPage(value) {
  if (typeof value !== "string") return "";
  const page = value.trim();
  return OPEN_PAGES.includes(page) ? page : "";
}

export function withoutOpenPage(query) {
  const nextQuery = { ...query };
  delete nextQuery[OPEN_PAGE_QUERY_KEY];
  return nextQuery;
}

export const BIRTHDAY_RETURN_OFFER_QUERY_KEY = "return_offer";
export const BIRTHDAY_RETURN_TEMPLATE_QUERY_KEY = "return_template";

export function getBirthdayFormRoute(storeCode, { offerUuid, templateUuid } = {}) {
  const route = { name: "changeMemberInfo", params: { store: storeCode } };
  const offer = getClaimOfferUuid(offerUuid);
  const template = getClaimOfferUuid(templateUuid);
  if (offer) route.query = { [BIRTHDAY_RETURN_OFFER_QUERY_KEY]: offer };
  else if (template) route.query = { [BIRTHDAY_RETURN_TEMPLATE_QUERY_KEY]: template };
  return route;
}

export function getBirthdayReturnRoute(storeCode, query = {}) {
  const offer = getClaimOfferUuid(query[BIRTHDAY_RETURN_OFFER_QUERY_KEY]);
  if (offer) return { path: `/${storeCode}`, query: { [CLAIM_OFFER_QUERY_KEY]: offer } };
  const template = getClaimOfferUuid(query[BIRTHDAY_RETURN_TEMPLATE_QUERY_KEY]);
  return template ? { path: `/${storeCode}/coupon/claim/${template}` } : null;
}
